import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessSessionsDataService, FitnessSessionsColumnsService } from '../../../services';
import { FitnessSession, FitnessSessionsResult } from '../../../interfaces';

@Component({
  selector: 'app-fitness-session-form',
  templateUrl: './fitness-session-form.component.html',
  styleUrls: ['./fitness-session-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessSessionFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public fitnessSession: FitnessSession = {};
  public fitnessSessionForm: FormGroup = new FormGroup({});
  public fitnessSessions: FitnessSession[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessSessionsDataService: FitnessSessionsDataService,
    public fitnessSessionsColumnsService: FitnessSessionsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'FitnessSessionFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Session - Edit');
        this.getFitnessSession(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessSession !== 'undefined') {
      this.fitnessSession = this.dynamicDialogConfig.data.fitnessSession;
    }
    if (typeof this.fitnessSession.id === 'undefined' || this.fitnessSession.id === null) {
      this.fitnessSession.id = null;
      this.fitnessSession.startTime = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.fitnessSession.recordingEnabled = false;
      this.fitnessSession.isPublished = false;
    }
    this.getFitnessSessions();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'FitnessSessionFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'FitnessSessionFormComponent');
  }

  getFitnessSession(id: number): void {
    this.isLoading = true;
    this.fitnessSessionsDataService.getFitnessSession(id).subscribe((response: FitnessSession|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessSession = response;
        this.prepareFrom();
      }
    });
  }

  getFitnessSessions(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessSessions !== 'undefined' && this.dynamicDialogConfig.data.fitnessSessions.length > 0) {
      this.fitnessSessions = this.dynamicDialogConfig.data.fitnessSessions;
      return;
    }
    this.fitnessSessionsDataService.getFitnessSessions(this.parameters).subscribe((response: FitnessSessionsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessSessions = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.fitnessSession.startTime = moment(this.fitnessSession.startTime).toDate();
    this.fitnessSessionForm = new FormGroup({
      id: new FormControl(this.fitnessSession.id, []),
      name: new FormControl(this.fitnessSession.name, [Validators.required, ]),
      nameAr: new FormControl(this.fitnessSession.nameAr, []),
      nameFr: new FormControl(this.fitnessSession.nameFr, []),
      startTime: new FormControl(this.fitnessSession.startTime, [Validators.required, ]),
      fitnessClass: new FormControl((typeof this.fitnessSession.fitnessClass === 'number') ? this.fitnessSession.fitnessClass : this.fitnessSession.fitnessClass?.id, [Validators.required, ]),
      coach: new FormControl((typeof this.fitnessSession.coach === 'number') ? this.fitnessSession.coach : this.fitnessSession.coach?.id, [Validators.required, ]),
      pushStreamUrl: new FormControl(this.fitnessSession.pushStreamUrl, []),
      pushStreamName: new FormControl(this.fitnessSession.pushStreamName, []),
      publicStreamUrl: new FormControl(this.fitnessSession.publicStreamUrl, []),
      vodUrl: new FormControl(this.fitnessSession.vodUrl, []),
      recordingEnabled: new FormControl(this.fitnessSession.recordingEnabled, [Validators.required, ]),
      isPublished: new FormControl(this.fitnessSession.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/fitness-sessions']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.fitnessSessionForm.controls).forEach((field: any) => {
        const control = this.fitnessSessionForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.fitnessSessionForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.fitnessSession = this.fitnessSessionForm.value;
    this.disableSubmit = true;
    console.log('fitnessSession', this.fitnessSession);
    if (typeof this.fitnessSession.id !== 'undefined' && this.fitnessSession.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.fitnessSessionsDataService.updateFitnessSession(this.fitnessSession).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSSESSIONUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSSESSIONNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.fitnessSessionsDataService.addFitnessSession(this.fitnessSession).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSSESSIONCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSSESSIONNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-fitness-session-form',
  templateUrl: './fitness-session-form.component.html',
  styleUrls: ['./fitness-session-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessSessionFormComponent extends FitnessSessionFormComponent {
}

